import React, { useState } from "react";

import { useDrugs, useDrugsHistoryByConcept } from "../Hooks/useDrugs";
import { Drugs } from "../../../components/MedicalRecords/Drugs";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { AuditTrail } from "../../Admin/AuditTrail";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { useTranslation } from "react-i18next";
import { ModalConceptHistory } from "../Modals/ModalConceptHistory";

export const DrugsListContainer = ({ mrn,medicalRecordNumber, entryId, expandedAll }) => {
    const { t } = useTranslation();
    const [drugs, query, totalSize, isLoading, handleTableChange, , setSearchTerm] = useDrugs(medicalRecordNumber, entryId);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="Drugs" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }
    const handleHistoryByConcept = (conceptId, _mrn) => {
        setModal(<ModalConceptHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.byConcept")}
            medicalRecordNumber={medicalRecordNumber || mrn}
            conceptId={conceptId}
            useHistoryHook={useDrugsHistoryByConcept}
            getConceptName={(row) => row.drug}
            getCycleSubtitle={(row) => [row.dose, row.unit, row.frequency].filter(Boolean).join(' ')}
        />)
    }

    if (entryId && totalSize === 0)
        return null;

    return (
        <ExpandableContent title={t("medicalRecords.drugs.title")} content="drugs" expandedAll={expandedAll}>
            {modal}
            <Drugs
                withCard={false}
                data={drugs}
                query={query}
                entryId={entryId}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistoryByConcept={handleHistoryByConcept}
                onSearchTermChange={setSearchTerm}
            />
        </ExpandableContent>
    );
}